const formatDateTime = (isoString) => {
    const date = new Date(isoString); // Parses the ISO string

    // Extracting Local Date
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Extracting Local Time
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;

    return `${formattedDate} ${formattedTime}`;
};

module.exports = formatDateTime;
